<template>
<section class="events__area pt-50 pb-120 p-relative">
   <div class="events__shape">
      <img class="events-1-shape" src="../../assets/img/events/events-shape.png" alt="">
    </div>
      <div class="container">
         <div class="row">
            <div class="col-xxl-12 d-flex justify-content-start">
               <div class="section__title-wrapper mb-60">
                  <h2 class="section__title">{{ $t('event.upcoming') }} <span class="yellow-bg yellow-bg-big">{{ $t('event.mainTitle1') }}<img src="../../assets/img/shape/yellow-bg.png" alt=""></span></h2>
                  <p>{{ $t('event.title') }} {{ tadbirlar?.results?.length }} {{ $t('event.titleThen') }}</p>
               </div>
            </div>
         </div>
         <div class="row">
            <div v-for="(vm, index) in tadbirlar?.results" :key="index" class="col-xxl-10 offset-xxl-1 col-xl-10 offset-xl-1 col-lg-10 offset-lg-1">
               <div class="events__item mb-10 hover__active">
                  <div class="events__item-inner d-sm-flex align-items-center justify-content-between white-bg">
                     <div class="events__content">
                        <div class="events__meta">
                           <span>{{vm?.start_date}}</span>
                           <span>{{vm?.start_time + ' - ' + vm?.end_time}}</span>
                           <span>{{ vm?.address}}</span>
                        </div>
                        <h3 class="events__title">
                           <router-link :to="`/event-details/${vm.id}`">
                               {{ 
                        getName({
                          nameUz: vm?.title_uz,
                          nameRu: vm?.title_ru,
                          nameLt: vm?.title,
                          nameEn: vm?.title_en,
                        })
                      }}
                     </router-link>
                        </h3>
                     </div>
                     <div class="events__more">
                        <router-link :to="`/event-details/${vm.id}`" class="link-btn">
                           {{ $t('actions.detail') }}
                           <i class="far fa-arrow-right"></i>
                           <i class="far fa-arrow-right"></i>
                        </router-link>
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </div>
   </section>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import BlogMixin from '../../mixins/blogMixin';

export default {
   name:'EventArea',
   mixins:[BlogMixin],
   data () {
      return {
        eventsList:[],
         eventData:[
            {
               id:1,
               title:'Sun’iy intellekt bo‘yicha xalqaro forum',
               date:'Mart 18, 2026',
               time:'12:00 - 14:30',
               city:'Toshkent shahar, Hilton Tashkent City'
            },
            {
               id:2,
               title:'Zoom orqali seminar',
               date:'Mart 26, 2026',
               time:'9:00 - 15:00',
               city:'Toshkent shahar, Mirzo Ulug‘bek tumani, Olimlar ko‘chasi, 49-uy'
            },
            {
               id:3,
               title:'Texnologiyalar haftaligi – 2025',
               date:'Aprel 10, 2026',
               time:'10:30 - 13:30',
               city:'Toshkent shahar, Mirzo Ulug‘bek tumani, Olimlar ko‘chasi, 49-uy'
            },
            {
               id:4,
               title:'Yashil makon',
               date:'Aprel 15, 2026',
               time:'10:30 - 12:00',
               city:'Toshkent shahar, Hilton Tashkent City'
            },
         ]
      }
   },
  created() {
   //   this.getEvents()
   this.getTadbirlar()
  },
  computed:{
     ...mapGetters('events', ['events']),
     ...mapGetters('tadbirlar', ['tadbirlar']),
  },
  methods:{
    ...mapActions('events', ['getEvents']),
    ...mapActions('tadbirlar', ['getTadbirlar']),
  }
};
</script>
